import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import Link from '../../shared/Link/Link';
import Button from '../../shared/Button/Button';
import TextField from '../../shared/FormFields/TextField';

import { passwordChange } from '../../../redux/modules/user';

import { MdLockOutline } from 'react-icons/md';
import './RecuperoPassword.scss';

class ResetPassword extends Component {
  componentDidMount() {
    const token = this.props.location.query.t;
    if (!token) {
      this.props.router.push('/');
    }
  }

  saveNewPassword = userData => {
    const token = this.props.location.query.t;
    const { password } = userData;
    this.props.passwordChange(token, password);
  };

  render() {
    const { error, passwordChanged } = this.props.user;
    const { siteName, siteUrl } = this.props;

    return (
      <div className="recupero-password">
        <Helmet
          title={'Reset Password'}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita - Reset Password`,
            },
            {
              name: 'keywords',
              content: `Reset Password, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/reset-password`,
            },
          ]}
        />
        <div className="container">
          <h1>Reset Password</h1>

          {!passwordChanged && (
            <div>
              <p className="text-center">
                Digita una nuova password per accedere al tuo account.
              </p>

              <form onSubmit={this.props.handleSubmit(this.saveNewPassword)}>
                <Field
                  name="password"
                  component={TextField}
                  type="password"
                  label="Inserisci nuova password"
                />
                <Field
                  name="confirmPassword"
                  component={TextField}
                  type="password"
                  label="Conferma password"
                />
                <div className="btn-container">
                  <Button type="submit" className="btn btn-thick btn-primary">
                    Salva nuova password
                  </Button>
                </div>
              </form>
            </div>
          )}

          {!!passwordChanged && (
            <div className="alert alert-success">
              <p>La tua nuova password è stata salvata correttamente!</p>
              <p>Effettua il login per proseguire con i tuoi acquisti.</p>
            </div>
          )}

          {!passwordChanged && error.length > 0 && (
            <div className="alert alert-danger">
              <p>È avvenuto un errore durante il reset della password.</p>
              <p>
                Il link potrebbe essere non corretto o scaduto. Prova ad
                effettuare una{' '}
                <Link to="/recupero-password">
                  Nuova richiesta di recupero password
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (values.password && !values.confirmPassword) {
    errors.confirmPassword = 'Richiesto';
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Le due password non coincidono';
  }

  return errors;
};

ResetPassword = reduxForm({
  form: 'password-reset',
  validate,
})(ResetPassword);

ResetPassword = withRouter(ResetPassword);

const mapStateToProps = state => {
  return {
    user: state.user,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
  };
};

export default connect(mapStateToProps, { passwordChange })(ResetPassword);
